/**
 * @copyright 2023 Chris Zuber <admin@kernvalley.us>
 */
export const HTML = 'http://www.w3.org/1999/xhtml';
export const SVG = 'http://www.w3.org/2000/svg';
export const XLINK = 'http://www.w3.org/1999/xlink';
export const MATHML = 'http://www.w3.org/1998/Math/MathML';
